<template>
  <q-item-label>
    <slot />
  </q-item-label>
</template>

<script>
export default {
  name: 'RItemLabel',
};
</script>
